module.exports = __webpack_public_path__ + "img/eduLeftImg.86f5296c.png";